
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="NoiseEmissionClassSvg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#545456" d="M17.59 17.241a.65.65 0 01-.51-1.051 7.657 7.657 0 000-9.424.65.65 0 111.023-.8 8.957 8.957 0 010 11.026.649.649 0 01-.513.249z"/><path fill="#545456" d="M15.004 15.882a.65.65 0 01-.552-.993 6.488 6.488 0 000-6.825.65.65 0 011.1-.685 7.788 7.788 0 010 8.2.65.65 0 01-.548.303zM12.131 14.563a.65.65 0 01-.579-.944 4.88 4.88 0 00.044-4.3.65.65 0 111.172-.563 6.18 6.18 0 01-.056 5.448.65.65 0 01-.58.36zM9.893 4c.075 0 .15.015.22.044a.651.651 0 01.388.612l-.117 13.654a.65.65 0 01-.394.6.582.582 0 01-.668-.176L6.53 15.388H4.61a.63.63 0 01-.609-.65V8.352a.63.63 0 01.608-.65h1.922l2.91-3.484A.591.591 0 019.892 4zm-.71 12.615L9.27 6.372 7.257 8.785a.591.591 0 01-.454.217H5.217v5.086h1.586a.59.59 0 01.454.217l1.925 2.31z"/></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'NoiseEmissionClassSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
